$(function () {

    //toggle main menu for mobile view
    $("#main-menu-toggle").click(function () { $("#main-nav").toggleClass("show"); });

    //toggle search bar in header
    const headSearch = document.getElementsByClassName("head-search");

    $("#search-toggle").click(function (e) {
        e.preventDefault();
        var searchToggle = $('#search-toggle');
        const searchToggleOffset = searchToggle.position().left;
        const searchOffset = (searchToggle.parent().parent().width() - searchToggleOffset);
        $(headSearch).toggleClass("show");
        $(headSearch).css({ position: "absolute" });
        $(headSearch).css("right", searchOffset + "px");
        if ($(headSearch).is(".show")) $(headSearch).focus();
        return false;
    });

    //submit search input in header
    $(headSearch).keydown(function (e) {
        if (e.key != "Escape" && e.key != 13) return true;
        //e.preventDefault();
        if (e.key == "Escape") $(headSearch).val("").removeClass("show").blur();
        return false;
    });

    //hero slider
    $(".slider").each(function () {
        const el = this;
        $(el).find(".slide:first-child").addClass("active");
        if ($(el).children(".slide").length < 2) return;
        var autoslide = setInterval(slideChange, 5000);
        function sliderPrev() { slideChange("prev", true); }
        function sliderNext() { slideChange("next", true); }
        function slideChange(direction = "next", fromClick = false) {
            const active = $(el).find(".slide.active");
            $(active).removeClass("active");
            if ($(active).is(direction == "next" ? ":last-child" : ".slider-controls + .slide")) $(el).children(direction == "next" ? ".slider-controls + .slide" : ".slide:last-child").addClass("active");
            else if (direction == "next") $(active).next().addClass("active");
            else $(active).prev().addClass("active");
            if (fromClick) { clearInterval(autoslide); autoslide = setInterval(slideChange, 5000); }
        }
        $(el).prepend("<div class=\"container slider-controls\"><div class=\"slider-prev\">&nbsp;</div><div class=\"slider-next\">&nbsp;</div></div>");
        $(el).find(".slider-prev").click(sliderPrev);
        $(el).find(".slider-next").click(sliderNext);
    });

    function resizehomeboxes() {
        var theheight = 0;
        $("#home-liketoknow .shadow-box").each(function () { $(this).css("height", "auto"); if (this.offsetHeight > theheight) theheight = this.offsetHeight; });
        $("#home-liketoknow .shadow-box").each(function () { $(this).css("height", theheight + "px") });
        //console.log("resizehomeboxes: " + theheight);
    }
    resizehomeboxes();
    window.addEventListener('resize', resizehomeboxes);

    function resizePublicRegisterBoxes() {
        var theheight = 0;
        $(".search-results .public-register-details").each(function () { $(this).css("height", "auto"); if (this.offsetHeight > theheight) theheight = this.offsetHeight; });
        $(".search-results .public-register-details").each(function () { $(this).css("height", theheight + "px") });
    }
    resizePublicRegisterBoxes();
    window.addEventListener('resize', resizePublicRegisterBoxes);

    //question accordion
    $(".accordion .toggle").click(function () {
        $(this).parent().siblings(".open").removeClass("open").children(".answer").hide(200);
        $(this).parent().toggleClass("open").children(".answer").toggle(200);
    });

    //$("table th").attr("data-breakpoints", "xs")
    $(".footable").footable();
});

function openToggle(clientid) {
    var _toggle = document.getElementById(clientid + "_toggle");
    var _parent = _toggle.parentElement
    _parent.className = "open";
    _parent.getElementsByClassName("answer")[0].style.display = "block";
    _toggle.scrollIntoView();
};

//home page news slider
(function () {
    let sliderCounter = 0; // helps keep IDs unique across multiple sliders

    function uniquifyIds(root, suffix) {
        const idMap = new Map();

        root.querySelectorAll('[id]').forEach(node => {
            const oldId = node.id;
            const newId = oldId + suffix;
            idMap.set(oldId, newId);
            node.id = newId;
        });

        const idRefAttrs = [
            'aria-labelledby',
            'aria-describedby',
            'aria-controls',
            'aria-owns',
            'aria-activedescendant',
            'for',
            'headers',
            'list'
        ];

        root.querySelectorAll('*').forEach(node => {
            idRefAttrs.forEach(attr => {
                if (node.hasAttribute(attr)) {
                    const raw = node.getAttribute(attr);
                    const parts = raw.split(/\s+/).map(x => idMap.get(x) || x);
                    node.setAttribute(attr, parts.join(' '));
                }
            });

            if (node.hasAttribute('href')) {
                const href = node.getAttribute('href');
                const m = href && href.match(/^#(.+)$/);
                if (m && idMap.has(m[1])) {
                    node.setAttribute('href', '#' + idMap.get(m[1]));
                }
            }
        });

        return root;
    }

    $(".news-slider").each(function () {
        const el = this;
        const sliderIdSuffix = `--dup${sliderCounter++}`;

        const originalWrapper = document.createElement('div');
        originalWrapper.innerHTML = el.innerHTML;

        const duplicateWrapper = originalWrapper.cloneNode(true);
        uniquifyIds(duplicateWrapper, sliderIdSuffix);

        el.innerHTML =
            '<div class="slider-controls"><div class="slider-prev">&nbsp;</div><div class="slider-next">&nbsp;</div></div>' +
            '<div class="news-slides"></div>';

        const ns = $(el).find(".news-slides")[0];
        while (originalWrapper.firstChild) ns.appendChild(originalWrapper.firstChild);
        while (duplicateWrapper.firstChild) ns.appendChild(duplicateWrapper.firstChild);

        $(ns.lastElementChild).prependTo(ns);

        function setMargin() {
            const articleWidth = ns.firstElementChild.offsetWidth;
            const windowWidth = $(el).width();
            const containerWidth = $(el).prev().width();
            const margin = windowWidth < (articleWidth * 2)
                ? articleWidth - ((windowWidth - articleWidth) / 2)
                : articleWidth - ((windowWidth - containerWidth) / 2);
            $(ns).css("margin-left", "-" + Math.floor(margin) + "px");
        }
        setMargin();
        window.addEventListener("resize", setMargin);

        $(el).find(".slider-prev").click(function () {
            $(ns.lastElementChild)
                .css("margin-left", "-" + ns.lastElementChild.offsetWidth + "px")
                .prependTo(ns)
                .animate({ "margin-left": 0 }, 200);
        });

        $(el).find(".slider-next").click(function () {
            $(ns.firstElementChild).animate(
                { "margin-left": "-=" + ns.firstElementChild.offsetWidth + "px" },
                200,
                function () { $(this).appendTo(ns).css("margin-left", 0); }
            );
        });
    });
})();

// Add scope attributes to table headers for accessibility
document.addEventListener("DOMContentLoaded", () => {
    (function () {
        document.querySelectorAll(".pmcontent table").forEach(table => {
            const thead = table.querySelector("thead");
            if (thead) {
                thead.querySelectorAll("th:not([scope])").forEach(th => {
                    th.setAttribute("scope", "col");
                });
            }

            table.querySelectorAll("tbody th:not([scope]), tfoot th:not([scope])").forEach(th => {
                th.setAttribute("scope", "row");
            });
        });
    })();
});

// Fix duplicate trailing dot links caused by content editor as these can be confusing for screen reader users
(function () {
    function fixDuplicateTrailingDotLinks(root) {
        root.querySelectorAll('.pmcontent a').forEach(function (a) {
            // Normalise the anchor's visible text to check it is just a "."
            var text = (a.textContent || '').replace(/\s+/g, '');
            if (text !== '.') return;

            // Check if there is a preceeding a tag <a>
            var prev = a.previousElementSibling;
            if (!prev || prev.tagName !== 'A') return;

            // Must be the same href, compare the raw attribute to avoid absolute URL normalisation issues
            var href1 = a.getAttribute('href') || '';
            var href2 = prev.getAttribute('href') || '';
            if (!href1 || href1 !== href2) return;

            // Replace the trailing linked "." with a plain text node "."
            // Preserve any original whitespace around the dot from the node's textContent
            a.replaceWith(document.createTextNode(a.textContent));
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { fixDuplicateTrailingDotLinks(document); });
    } else {
        fixDuplicateTrailingDotLinks(document);
    }
})();